import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';

import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { isScullyRunning } from '@scullyio/ng-lib';
import { switchMap, timer } from 'rxjs';

import { I18nDataLoadingService } from './shared/custom-translate/i18n-data-loading.service';

@Component({
  selector: 'placeme-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private localizeRouterService: LocalizeRouterService,
    private i18nDataLoadingService: I18nDataLoadingService,
    private translateService: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.loadFreshI18n(this.localizeRouterService.parser.currentLang);
    this.document.documentElement.lang = translateService.currentLang;
    translateService.onLangChange.subscribe(event => (this.document.documentElement.lang = event.lang));
  }

  private loadFreshI18n(lang: string): void {
    if (!isScullyRunning()) {
      timer(500)
        .pipe(switchMap(() => this.i18nDataLoadingService.getTranslation(lang, true)))
        .subscribe(data => {
          this.translateService.setTranslation(lang, data);
          this.translateService.use(lang);
        });
    }
  }
}
